import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryAspectMounted } from './ConditionRegistryAspectMounted';
export class ConditionRegistryAspect extends ConditionRegistryCategory {
    label = 'Aspekt';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_mounted = new ConditionRegistryAspectMounted(this);
    isAspectMounted = () => new ConditionRegistryItem({
        eval: ({ aspect }) => aspect.aspectMounts.isAspectMounted
    });
    hasAspectLocalContent = () => new ConditionRegistryItem({
        eval: ({ aspect }) => aspect.persistentAspect.aspectContent.local.hasContent
    });
}
